import { GetAdminEventsResponse } from '@orbit/api-types'
import { useAdminFilter } from '@pages/Admin/AdminFilterContext'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

interface UseAdminEventsParams {
	page: number
	pageSize?: number
	/** Search by event name or trip name; falsy values are omitted. */
	q?: string
}

/**
 * Fetches a page of the admin events list (GET /v1/admin/events), scoped to the
 * global creation-date range from {@link useAdminFilter} plus page and search term.
 * Previous data is kept while the next page loads. Gated server-side by AdminGuard.
 */
export const useAdminEvents = ({ page, pageSize, q }: UseAdminEventsParams) => {
	const { from, to, includeInternal } = useAdminFilter()

	return useQuery<GetAdminEventsResponse>({
		queryKey: queryKeys.adminEvents(from, to, page, pageSize, q, includeInternal),
		queryFn: async () => {
			const response = await api.get<GetAdminEventsResponse>('/admin/events', {
				params: { from, to, page, pageSize, q: q || undefined, includeInternal: includeInternal || undefined },
			})
			return response.data
		},
		placeholderData: keepPreviousData,
	})
}
